import { Router } from '@angular/router';
import { DocumentsErrorCodes } from '@app/translations/default-constants/toaster/error-codes/document.type';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import { Store } from '@ngxs/store';
import { ConfirmDialogService } from '@app/finxone-web-frontend/app/Modules/shared/components-library/confirmation-dilog/confirmation-dialog.service';
import { findAndShowAlertFromCode } from '../alert-code-utils/alert-code.utils';
import { showUploadFileConfirmDialog } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/upload-confirm-dialog.utils';

export async function uploadFileViaFlutterWebView(
  flutterWebView: any,
  flutterRequestData: Record<string, any>,
  confirmDialogService: ConfirmDialogService,
  store: Store,
  router: Router,
  alertHandlerService: AlertHandlerService,
  onSuccess: (flutterResponse: any) => void,
): Promise<void> {
  try {
    const pickerResponse = await flutterWebView.callHandler('filePickerHandler', [flutterRequestData]);

    if (!pickerResponse || pickerResponse.status === false) return;

    const confirmed = await showUploadFileConfirmDialog(null, confirmDialogService, pickerResponse.name);
    if (!confirmed) return;

    const flutterResponse = await flutterWebView.callHandler('confirmFileUploadHandler', [
      {
        ...flutterRequestData,
        files: pickerResponse.files,
        fileBytes: pickerResponse.fileBytes,
        name: pickerResponse.name,
      },
    ]);

    if (!flutterResponse) {
      findAndShowAlertFromCode(store, router, alertHandlerService, [
        DocumentsErrorCodes.DOCUMENT_UPLOAD_FAILED,
      ]);
      return;
    }

    onSuccess(flutterResponse);
  } catch (error) {
    console.error('Error from flutterWebView:', error);
    findAndShowAlertFromCode(store, router, alertHandlerService, [
      DocumentsErrorCodes.DOCUMENT_UPLOAD_FAILED,
    ]);
  }
}
